import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { i18n } from 'core/i18n';
import InputField from 'components/inputField/index';
import Button from 'components/button/index';
import Dialog from 'components/dialog/index';
import queryString from 'query-string';

import './login.css';

import { changeMima, closeSuccesDailog } from './action';

class ForgotIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mima: '',
      confirmMima: '',
    };
  }

  componentDidMount() {
    console.log('ForgotMima', this.props);
  }

  render() {
    const self = this,
      {
        state: _state,
        props
      } = self,
      {
        state,
        dispatch = () => { }
      } = props,
      {
        errors,
        showResultDialog
      } = state,
      {
        mima,
        confirmMima,
      } = _state;
    
    return (
      <div className='login-frame'>
        {/* 背景圖 */}
        <img className='login-bg left-top' alt='' src={require('assets/images/bg-img-1.svg')} />
        <img className='login-bg right-bottom' alt='' src={require('assets/images/bg-img-2.svg')} />
        <img className='login-bg flight' alt='' src={require('assets/images/bg-img-4.svg')} />
        {/* 登入區塊 */}
        <div className='login-panel'>
          <div className='login-panel-title'>
            {i18n('password_change_pw')}
          </div>
          <div className='login-panel-tip'>{i18n('password_new_pw')}</div>
          <div className='login-panel-input-field'>
            <InputField
              type={'password'}
              inputType={'password'}
              placeholder={i18n('please_input')}
              onBlurActEvent={(data) => {
                this.setState({
                  mima: data
                });
              }}
              value={mima}
              validateMessage={errors && errors.mima ? i18n('error_password') : null}
            />
          </div>
          <div className='login-panel-tip'>{i18n('password_confirm_pw')}</div>
          <div className='login-panel-input-field'>
            <InputField
              type={'password'}
              inputType={'password'}
              placeholder={i18n('please_input')}
              onBlurActEvent={(data) => {
                this.setState({
                  confirmMima: data
                });
              }}
              value={confirmMima}
              validateMessage={errors && errors.confirmMima ? i18n('error_confirm_password') : null}
            />
          </div>
          <Button
            className={'primary-button login-panel-button'}
            onClick={() => {
              let token = queryString.parse(this.props.location.search).id || '';
              let requestData = {
                mima: mima,
                confirmMima: confirmMima,
                token: token
              };
              dispatch(changeMima(requestData));
            }}
          >
            {i18n('confirm')}
          </Button>
        </div>
        {/* 密碼變更結果 dialog */}
        <Dialog
          dialogId='login-forget-pw-dialog'
          maxWidth='md'
          zIndex={2000}
          open={!!showResultDialog}
          onClose={() => {
            dispatch(closeSuccesDailog(this.props));
          }}
          title={i18n('password_change_pw')}
          actionsClassName='login-forget-pw-dialog'
          actions={[
            <Button
              className={'primary-button login-panel-button'}
              onClick={() => {
                dispatch(closeSuccesDailog(this.props));
              }}
            >
                {i18n('confirm')}
            </Button>
          ]}
        >
          <div className='login-forget-pw-dialog-body'>
            <div className='body-title'>{i18n('success_change_password')}</div>
          </div>
        </Dialog>
      </div>
    );
  }
}

let mapStateToProps = state => {
  return {
    state: state.loginReducer
  };
};

export default connect(mapStateToProps)(withRouter(ForgotIndex));
